import Table from "sap/m/Table";
// @ts-expect-error TextAreaRenderer is no public module..
import TableRenderer from "sap/m/TableRenderer";
import { MetadataOptions } from "sap/ui/core/Element";

/**
 * @name com.unitrade.crm.controls.bettertable.BetterTable
 */
export default class BetterTable extends Table {
    bPreventMassSelection: boolean;

    // The following three lines were generated and should remain as-is to make TypeScript aware of the constructor signatures
    constructor(idOrSettings?: string | $BetterTableSettings);
    constructor(id?: string, settings?: $BetterTableSettings);
    constructor(id?: string, settings?: $BetterTableSettings) { super(id, settings); }

    static readonly metadata: MetadataOptions = {
        properties: {
            showSelectAll: {
                type: "boolean",
                bindable: true,
            }
        }
      };
    static renderer = TableRenderer;

    setShowSelectAll(bValue: boolean): this {
        this.bPreventMassSelection = !bValue;
        this.setProperty("showSelectAll", bValue);
        return this;
    };
}